import Vue from 'vue';
import Vuex from 'vuex';
import * as account from './modules/account';
import * as jobs from './modules/jobs';
import * as keywordAnalysis from './modules/keywordAnalysis';
import * as keywords from './modules/keywords';
import * as language from './modules/language';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    account,
    jobs,
    keywordAnalysis,
    keywords,
    language,
  },
  state: {},
  mutations: {},
  actions: {},
});
